import Timer from '../common/timer';
// import Application from '../common/application';

const NotRegistered = ({ handleHubChange }) => {
  return (
    <div className='grid grid-cols-2 gap-3'>
      <Timer handleHubChange={handleHubChange} />
      {/* <Application handleHubChange={handleHubChange} /> */}
    </div>
  );
};

export default NotRegistered;
